import { render, staticRenderFns } from "./GoogleStoreWidget.vue?vue&type=template&id=62563197"
import script from "./GoogleStoreWidget.vue?vue&type=script&lang=js"
export * from "./GoogleStoreWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports